import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Fire-and-forget analytics
export const track = (event, properties = {}) => {
  api.post("/analytics/track", { event, properties }).catch(() => {});
};

// Public share URL (Open Graph rich) for a call
export const shareUrl = (shortId) => `${BACKEND_URL}/api/r/${shortId}`;
export const receiptUrl = (shortId) => `${window.location.origin}/c/${shortId}`;
export const ogImageUrl = (shortId, size = "landscape") =>
  `${BACKEND_URL}/api/r/${shortId}/og.png?size=${size}`;
